export default __webpack_public_path__ + "static/media/salt.0e290c1d.svg";